// npm
import React from 'react'
import { Box, Grid, Container, styled } from '@mui/material'

// components
import Card from '@molecules/cards/Card'
import Subtitle from '@molecules/headings/Subtitle'
import MainHeading, { MainHeadingProps } from '@molecules/headings/MainHeading'

interface Props {
  data: Queries.DatoCmsContentSectionServiceLanding
}

const StyledContainer = styled(Container)(({ theme }) => ({
  [theme.breakpoints.down('lg')]: {
    maxWidth: theme.breakpoints.values.md,
  },
}))

const ContentSectionServiceLanding = ({ data }: Props) => {
  const mainHeadingProps: MainHeadingProps = {
    typographyProps: {
      variant: 'h2',
      color: 'inherit',
      textAlign: 'center',
      lineHeight: '1',
      mb: 8,
    },
    lineBreaksProps: {
      keyId: `heading-${data.id}`,
      text: data.mainHeadingNode.childMarkdownRemark.html,
      breakpoint: 'xs',
    },
  }

  return (
    <Box
      pb={{ xs: 6, lg: 13 }}
      sx={{
        position: 'relative',
        backgroundColor: 'primary.light',
        overflow: 'hidden',
      }}
    >
      <StyledContainer maxWidth="xl">
        <Box sx={{ textAlign: 'center' }}>
          <Subtitle
            text={data.smallHeading}
            typographyProps={{ component: 'h2' }}
            borderType="bottom"
          />
          <MainHeading {...mainHeadingProps} />
        </Box>
        <Grid container spacing={2}>
          {data.services.map((service) => {
            // return <Card data={service} />
            return (
              <Grid item sm={6} lg={4} xl={3} key={`grid-${service.id}`}>
                <Card data={service} />
              </Grid>
            )
          })}
        </Grid>
      </StyledContainer>
    </Box>
  )
}

export default ContentSectionServiceLanding
